import {getMethod} from '~/api'

async function get() {
    return await getMethod('/api/ownVisaCustomFields/list')
}

export {get}
